const COPY = {
  SOCIAL_PROOF: {
    id: 'Pricing.copy.SocialProofDesc',
    defaultMessage: 'Trusted by 300K+ organizations worldwide, including 95% of the Fortune 500',
    desc: {
      id: 'Pricing.copy.SocialProofDesc',
      message: '[Type: String][Vis.: low] - A string in pricing experiment GROW-2792 of companies who use SurveyMonkey',
      project: 'GROW-2792',
    },
  },
};

export default COPY;
